import React from 'react'
import styled from 'styled-components'

const StyledSvgWrapper = styled.div<{ $width: string; $height: string }>`
  width: ${({ $width }) => $width};
  height: ${({ $width }) => $width};
`

export const OutlineStar = ({ size, ...props }: { size: string }) => {
  return (
    <StyledSvgWrapper $width={size} $height={size}>
      <svg
        width="100%"
        height="100%"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M17.7935 2.89352L19.9892 7.34258C20.5719 8.52315 21.6981 9.34143 23.001 9.53074L27.9108 10.2442C29.5512 10.4826 30.2062 12.4985 29.0192 13.6556L25.4664 17.1187C24.5237 18.0376 24.0935 19.3616 24.316 20.6592L25.1547 25.5492C25.435 27.183 23.7201 28.4289 22.2528 27.6575L17.8614 25.3488C16.6961 24.7362 15.3039 24.7362 14.1386 25.3488L9.74715 27.6575C8.2799 28.4289 6.56504 27.183 6.84526 25.5492L7.68395 20.6592C7.90651 19.3616 7.47631 18.0376 6.53357 17.1187L2.98078 13.6556C1.79375 12.4985 2.44877 10.4826 4.08921 10.2442L8.99904 9.53074C10.3019 9.34143 11.4281 8.52315 12.0108 7.34258L14.2065 2.89352C14.9402 1.40703 17.0598 1.40703 17.7935 2.89352Z"
          stroke="currentColor"
          strokeWidth="2"
        />
      </svg>
    </StyledSvgWrapper>
  )
}
